import * as React from 'react'

import { useAppConfig } from '../providers/AppConfigProvider'

const GTAG_SCRIPT_ID = 'google-analytics-gtag'

export default function GoogleAnalytics() {
  const { googleAnalyticsTagId } = useAppConfig()

  React.useEffect(() => {
    if (!googleAnalyticsTagId || document.getElementById(GTAG_SCRIPT_ID)) {
      return
    }

    const encodedTagId = encodeURIComponent(googleAnalyticsTagId)

    const script = document.createElement('script')
    script.async = true
    script.id = GTAG_SCRIPT_ID
    script.src = `https://www.googletagmanager.com/gtag/js?id=${encodedTagId}`
    document.head.appendChild(script)

    const inlineScript = document.createElement('script')
    inlineScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${encodedTagId}');
    `
    document.head.appendChild(inlineScript)
  }, [googleAnalyticsTagId])

  return null
}
